
// import axios from'axios';
// Configuration des variables d'environnement
const ENV = {
  BACKEND_LOGIN_URL: import.meta.env.VITE_BACKEND_LOGIN_URL ,
  BACKEND_LOGOUT_URL: import.meta.env.VITE_BACKEND_LOGOUT_URL 
};

// Initier la connexion OAuth - redirige vers le backend
export const initiateAdminOAuthLogin = async () => {
  try {
    // const response = await axios.get(ENV.BACKEND_LOGIN_URL);
    const response = await fetch(ENV.BACKEND_LOGIN_URL,
       {
      credentials:"include"
    }
  );
    
    // if (response.status === 302) {
      if (response.status === 200) {
        const data = await response.json();
    //     console.log("reponse statu",response.status);
    // console.log("reponse redirect ?",response.redirected);
    // console.log("reponse url ?", response.url);
      // Rediriger vers la page de connexion si la requête réussie
      // window.location.href = ENV.BACKEND_LOGIN_URL;
      window.location.href = data.url;
    } else {
      
      console.error('Erreur lors de la connexion:', response.statusText);
    }
  } catch (error) {
    console.error('Erreur lors de la redirection vers la page de connexion:', error);
  }
};



// export const initiateAdminOAuthLogin = () => {
//   try {
//     window.location.href = ENV.BACKEND_LOGIN_URL;
    
//   } catch (error) {
//     console.error('Erreur lors de la redirection vers la page de connexion:', error);
//   }
// };


export const initiateLogOut = () => {
  try {
    window.location.href = ENV.BACKEND_LOGOUT_URL;
    localStorage.removeItem('company');
  } catch (error) {
    console.error('Erreur lors de la redirection vers la page de déconnexion:', error);
  }
};

// // Initier la déconnexion - redirige vers le backend
// export const initiateLogOut = async () => {
//   try {
//     const response = await fetch(ENV.BACKEND_LOGOUT_URL,
//       {
//         credentials:"include"
//       }
//     );
//     if (response.status === 200) {
//       window.location.href = response.url;
//     } else {
      
//       console.error('Erreur lors de la connexion:', response.statusText);
//     }
//   } catch (error) {
//     console.error('Erreur lors de la redirection vers la page de déconnexion:', error);
//   }
// };

export default { initiateAdminOAuthLogin, initiateLogOut };





// // Signatuture dans le front pas sécurisé
// import { SignJWT,  } from 'jose';
// import * as jose from 'jose';

// // Configuration des variables d'environnement
// const ENV = {
//   REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
//   OAUTH_AUTHORIZATION_URL: import.meta.env.VITE_REDIRECT_Otenti,
//   POST_LOGOUT_URI: import.meta.env.VITE_REDIRECT_post_logout_redirect_uri,
//   CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
//   CLIENT_SECRET: import.meta.env.VITE_CLIENT_SECRET,
//   USER_TYPE: import.meta.env.VITE_USER_TYPE,
//   AUDIENCE: import.meta.env.VITE_AUDIENCE,
//   PRIVATE_KEY_PATH: import.meta.env.VITE_PRIVATE_KEY_PATH,
//   PRIVATE_KEY: import.meta.env.VITE_PRIVATE_KEY
// };

// // Helper functions
// const base64URLEncode = (buffer: ArrayBuffer): string => {
//   return btoa(String.fromCharCode(...new Uint8Array(buffer)))
//     .replace(/\+/g, '-')
//     .replace(/\//g, '_')
//     .replace(/=+$/, '');
// };

// const generateCodeVerifier = (): string => {
//   const array = new Uint8Array(32);
//   crypto.getRandomValues(array);
//   return base64URLEncode(array);
// };

// const generateCodeChallenge = async (verifier: string): Promise<string> => {
//   const encoder = new TextEncoder();
//   const hash = await crypto.subtle.digest(
//     'SHA-256',
//     encoder.encode(verifier)
//   );
//   return base64URLEncode(hash);
// };

// // Génération JWT
// const generateClientAssertion = async (): Promise<string> => {
//   // const privateKey = await loadPrivateKey();
//   const privatekey = ENV.PRIVATE_KEY;
//   //  const privatekey= `-----BEGIN PRIVATE KEY-----
//   //  MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDYgoU9YKfEgqdm
//   //  KslPdvuK0++l5abCmsccCUIIf9tQoPIWMpzUBObVrUReJ0NmfwhedkHu/khemRj8
//   //  W0MTiub5b6ntYlgOFKigkUbxeoIMZU2kYqOqxL/LC801Cx+YfvIEY2O6gA8aZxTv
//   //  CDrZB5Zy1UvU5OSlwicafI/G+icDTdb51xE9cN77Hwx/WsRepzR3ZJBn7da7dyHJ
//   //  JZR2Qd/IpMI7LxL1U1SGeaORHoS6wFkSaM3l67ieKyOgRw25x8qAayIHNFNw7pl4
//   //  VWPIqTHaj/tApxoXwZugGf3JgVXr/D7l+CJ9QdGCgsIZK86UKa2q2TU8s9vAbq+u
//   //  Y0Eh9THzAgMBAAECggEAOUc+bKB3gdt24eaL34QAxBeRnPgGiBFef6JLX+hDYy9R
//   //  HGJDbyvkzb7LCYWlpSYSVrs+cjW/e5dRLuIN+suSk4bhE7YiyYbZnbERba0VXqYm
//   //  Rkj6N6FZhCQZI+FPeI6NBHAu4BYk6L1AooQw3V3OhY68QxRTES8uHSm6988SJyMh
//   //  3jSnXBmVPi9zxfqZ37G9mewld9FYBFJEsi7YYbkAS9pg93YhiTKlH9rn2fusDHSk
//   //  svAD79ULlT1Ntax+y4qqbwUF+mGmVu1QUdjGoAHeR7lIH9dFJXZAP2Kl5xjfgs7t
//   //  LYVmPGLGxSdFn/LWNYjYiZ4PtRNENHdIPp1yMYzI4QKBgQD6qoTY9BkBmhUibEx/
//   //  /E1LGVZP3aEAGxHbz+zAXRbAowbSL2ETm6FWQy07C/lLHxGCd5PtgMy5UgPi7Iu+
//   //  3aFOn9ktJjr3E0XLcHo7EH+dT1GxMIKtF+JumRMDZIOk8LE9Ts2/P15R4OBWhm9g
//   //  aJnAgYxPATHsew+ObzlXhF9ouQKBgQDdHfA+eg39N2P0F/tXGiehrBvJPMzTeMLt
//   //  2QpeYZ2rlNkxfPMLJJjE92AFV/D0n3twK26R57hUC7v0Ul3WSU2VKPUa89HtSwff
//   //  6Lb6KvCzQv0WkyYJDrR6o5W1prbl0P+0IBcMe/n0RycALqZ8ondMAalejXC6nz2S
//   //  nap5+bxCCwKBgDquHHdlfU0gsv3h+G6ls7p27fu4WG5b5+xbWoMVx7PE9l3R9ZnP
//   //  fw9gnoAKJ4vsc/7k215oHoTrrDk9QuGlpJNxXDfzkS4x9s7PP+3/yMAcx3UBdDXt
//   //  N3bIoujSaPb92aAOiJ/Sx9PHHv1ib0RUeFnWefAsyXEgxd2EMBpKxMMRAoGAA2XF
//   //  XkBj3KMwPvzrWMBHIZ3SY3oyr4EohZ0TIrYfRRapa7A+z8oFKumeKRbb1fZpYCTa
//   //  sxU7aNcxUSS+2l8P+R3C/mIGtL21ZkReI2PrhOWfm+ww5my6azP+RedE4i0e8LaZ
//   //  hBCXm6BIQiF1X27jpGBWKOTFeaieupT/nJYwxVcCgYBDOxraZdHlH1Jt7FdyouGo
//   //  ON6LGH1vtHwS5YMPB1CCfpKgQy2itrTaDKsseJsr5m1sUY8LPW2KfePvTzAI3z5d
//   //  DyFhn7SA3QQe3UfuMRU5MRSfSuSr/s4ZXoOr7JssIirUIx0Aih86Dihp+P0mIl+7
//   //  ol2xhbK1fg+kaOT2We0L4A==
//   //  -----END PRIVATE KEY-----`;
   
//    const privateKey2 = await jose.importPKCS8( privatekey.trim(), 'RS256');
//   return new SignJWT({
//     client_id: ENV.CLIENT_ID,
//     iss: ENV.CLIENT_ID,
//     sub: ENV.CLIENT_ID,
//     aud: ENV.AUDIENCE
//   })
//     .setProtectedHeader({ alg: 'RS256', kid: ENV.CLIENT_ID })
//     .setIssuedAt()
//     .setExpirationTime('5m')
//     .sign(privateKey2);
// };

// // Flux OAuth
// export const initiateAdminOAuthLogin = async () => {
//   try {
//     const [jwt, codeVerifier] = await Promise.all([
//       generateClientAssertion(),
//       generateCodeVerifier()
//     ]);

//     localStorage.setItem('code_verifier', codeVerifier);
    
//     const params = new URLSearchParams({
//       response_type: 'code',
//       client_id: ENV.CLIENT_ID,
//       redirect_uri: ENV.REDIRECT_URI,
//       scope: 'openid email profile offline_access',
//       code_challenge: await generateCodeChallenge(codeVerifier),
//       code_challenge_method: 'S256',
//       client_assertion: jwt,
//       client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
//       state: crypto.randomUUID(),
//       user_type: ENV.USER_TYPE
//     });

//     window.location.href = `${ENV.OAUTH_AUTHORIZATION_URL}/connect/authorize?${params}`;
//   } catch (error) {
//     console.error('Erreur authentification:', error);
//     // Gérer l'erreur
//   }
// };

// // Déconnexion
// export const initiateLogOut = () => {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('id_token');
//   localStorage.removeItem('code_verifier');

//   const params = new URLSearchParams({
//     client_id: ENV.CLIENT_ID,
//     post_logout_redirect_uri: ENV.POST_LOGOUT_URI
//   });

//   window.location.href = `${ENV.OAUTH_AUTHORIZATION_URL}/connect/logout?${params}`;
// };

// export default { initiateAdminOAuthLogin, initiateLogOut };


// // UTILISANT LA CLe ailleur 
// import { SignJWT } from 'jose';
// import { readFile } from 'node:fs/promises';
// import * as jose from 'jose';

// // Configuration des variables d'environnement
// const ENV = {
//   REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
//   OAUTH_AUTHORIZATION_URL: import.meta.env.VITE_REDIRECT_Otenti,
//   POST_LOGOUT_URI: import.meta.env.VITE_REDIRECT_post_logout_redirect_uri,
//   CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
//   CLIENT_SECRET: import.meta.env.VITE_CLIENT_SECRET,
//   USER_TYPE: import.meta.env.VITE_USER_TYPE,
//   AUDIENCE: import.meta.env.VITE_AUDIENCE,
//   PRIVATE_KEY_PATH: import.meta.env.VITE_PRIVATE_KEY_PATH
// };

// // Helper functions
// const base64URLEncode = (buffer: ArrayBuffer): string => {
//   return btoa(String.fromCharCode(...new Uint8Array(buffer)))
//     .replace(/\+/g, '-')
//     .replace(/\//g, '_')
//     .replace(/=+$/, '');
// };

// const generateCodeVerifier = (): string => {
//   const array = new Uint8Array(32);
//   crypto.getRandomValues(array);
//   return base64URLEncode(array);
// };

// const generateCodeChallenge = async (verifier: string): Promise<string> => {
//   const encoder = new TextEncoder();
//   const hash = await crypto.subtle.digest(
//     'SHA-256',
//     encoder.encode(verifier)
//   );
//   return base64URLEncode(hash);
// };

// // Génération JWT
// const generateClientAssertion = async (): Promise<string> => {
//   try {
//     const privateKeyContent = await readFile(ENV.PRIVATE_KEY_PATH, 'utf8');
//     const privateKey = await jose.importPKCS8(privateKeyContent.trim(), 'RS256');

//     return new SignJWT({
//       client_id: ENV.CLIENT_ID,
//       iss: ENV.CLIENT_ID,
//       sub: ENV.CLIENT_ID,
//       aud: ENV.AUDIENCE
//     })
//       .setProtectedHeader({ alg: 'RS256', kid: ENV.CLIENT_ID })
//       .setIssuedAt()
//       .setExpirationTime('5m')
//       .sign(privateKey);
//   } catch (error) {
//     console.error('Erreur lors de la génération de la client assertion:', error);
//     throw new Error('Échec de la génération du JWT');
//   }
// };

// // Flux OAuth
// export const initiateAdminOAuthLogin = async () => {
//   try {
//     const [jwt, codeVerifier] = await Promise.all([
//       generateClientAssertion(),
//       generateCodeVerifier()
//     ]);

//     localStorage.setItem('code_verifier', codeVerifier);
    
//     const params = new URLSearchParams({
//       response_type: 'code',
//       client_id: ENV.CLIENT_ID,
//       redirect_uri: ENV.REDIRECT_URI,
//       scope: 'openid email profile offline_access',
//       code_challenge: await generateCodeChallenge(codeVerifier),
//       code_challenge_method: 'S256',
//       client_assertion: jwt,
//       client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
//       state: crypto.randomUUID(),
//       user_type: ENV.USER_TYPE
//     });

//     window.location.href = `${ENV.OAUTH_AUTHORIZATION_URL}/connect/authorize?${params}`;
//   } catch (error) {
//     console.error('Erreur authentification:', error);
//     // Gérer l'erreur selon vos besoins
//   }
// };

// // Déconnexion
// export const initiateLogOut = () => {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('id_token');
//   localStorage.removeItem('code_verifier');

//   const params = new URLSearchParams({
//     client_id: ENV.CLIENT_ID,
//     post_logout_redirect_uri: ENV.POST_LOGOUT_URI
//   });

//   window.location.href = `${ENV.OAUTH_AUTHORIZATION_URL}/connect/logout?${params}`;
// };

// export default { initiateAdminOAuthLogin, initiateLogOut };

// cryptage 
// import * as jose from 'jose';


// // Récupération des variables d'environnement avec des valeurs par défaut
// const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI;
// const OAUTH_AUTHORIZATION_URL = import.meta.env.VITE_REDIRECT_Otenti;
// const Post_logout = import.meta.env.VITE_REDIRECT_post_logout_redirect_uri;
// const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
// const CLIENT_SECRET = import.meta.env.VITE_CLIENT_SECRET;
// const USER_TYPE = import.meta.env.VITE_USER_TYPE;
// const AUDIENCE = import.meta.env.VITE_AUDIENCE;
// const PRIVATE_KEY_PASSWORD = import.meta.env.VITE_PRIVATE_KEY_PASSWORD; // Mot de passe pour déchiffrer la clé privée
// const PRIVATE_KEY_PATH = import.meta.env.VITE_PRIVATE_KEY_PATH  // Chemin vers le fichier de clé privée

// // Fonction pour générer un code verifier aléatoire
// const generateCodeVerifier = (): string => {
//   const array = new Uint8Array(32);
//   window.crypto.getRandomValues(array);
//   return base64URLEncode(array);
// };

// // Fonction pour encoder en base64URL
// const base64URLEncode = (buffer: ArrayBuffer): string => {
//   return btoa(String.fromCharCode(...new Uint8Array(buffer)))
//     .replace(/\+/g, '-')
//     .replace(/\//g, '_')
//     .replace(/=+$/, '');
// };

// // Fonction pour générer le code challenge à partir du code verifier
// const generateCodeChallenge = async (codeVerifier: string): Promise<string> => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(codeVerifier);
//   const hash = await window.crypto.subtle.digest('SHA-256', data);
//   return base64URLEncode(hash);
// };

// // Fonction pour charger et déchiffrer la clé privée encryptée
// const loadAndDecryptPrivateKey = async (): Promise<jose.KeyLike> => {
//   try {
//     // Charger le fichier de clé privée
//     const response = await fetch(PRIVATE_KEY_PATH);
//     if (!response.ok) {
//       throw new Error(`Impossible de charger la clé privée: ${response.status} ${response.statusText}`);
//     }
    
//     const encryptedPrivateKey = await response.text();
    
//     if (!PRIVATE_KEY_PASSWORD) {
//       throw new Error('Mot de passe pour la clé privée non configuré dans les variables d\'environnement');
//     }
    
//     // Utiliser jose.js pour importer la clé PKCS#8 encryptée
//     try {
//       // Pour les versions récentes de jose.js qui acceptent uniquement 3 arguments
//       const privateKey = await jose.importPKCS8( encryptedPrivateKey.trim(), 'RS256', {
//         extractable: true
//       });
      
//       return privateKey;
//     } catch (error) {
//       console.error('Erreur lors du déchiffrement de la clé privée:', error);
//       throw new Error('Échec du déchiffrement de la clé privée: mot de passe incorrect ou format invalide');
//     }
//   } catch (error) {
//     console.error('Erreur lors du chargement/déchiffrement de la clé privée:', error);
//     throw error;
//   }
// };

// // Fonction pour générer le JWT dans le frontend
// const generateJWT = async (): Promise<string | null> => {
//   try {
//     // Charger et déchiffrer la clé privée
//     const privateKey = await loadAndDecryptPrivateKey();

//     const jwt = await new jose.SignJWT({
//       client_id: CLIENT_ID,
//       iss: CLIENT_ID,
//       sub: CLIENT_ID,
//       aud: AUDIENCE,
//       iat: Math.floor(Date.now() / 1000),
//       exp: Math.floor(Date.now() / 1000) + 300,
//     })
//       .setProtectedHeader({ alg: 'RS256', kid: CLIENT_ID })
//       .sign(privateKey);

//     console.log('JWT généré avec succès');
//     return jwt;
//   } catch (error) {
//     console.error('Erreur lors de la génération du JWT:', error);
//     return null;
//   }
// };

// // Fonction principale pour initier la connexion OAuth
// export const initiateAdminOAuthLogin = async () => {
//   console.log('Démarrage de initiateAdminOAuthLogin');

//   // Étape 1 : Générer le JWT signé dans le frontend
//   const jwt = await generateJWT();
//   if (!jwt) {
//     console.error('Échec de la génération du JWT. Impossible de continuer.');
//     return;
//   }

//   // Étape 2 : Générer le code verifier et le code challenge
//   const codeVerifier = generateCodeVerifier();
//   localStorage.setItem('code_verifier', codeVerifier);
//   console.log('code_verifier généré');

//   const codeChallenge = await generateCodeChallenge(codeVerifier);
//   console.log('code_challenge généré');

//   // Étape 3 : Construire l'URL d'autorisation
//   const oauthParams = {
//     response_type: 'code',
//     client_id: CLIENT_ID,
//     client_secret: CLIENT_SECRET,
//     redirect_uri: REDIRECT_URI,
//     user_type: USER_TYPE,
//     scope: 'openid email profile offline_access',
//     state: Math.random().toString(36).substring(2),
//     code_challenge: codeChallenge,
//     code_challenge_method: 'S256',
//     client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
//     client_assertion: jwt,
//   };

//   console.log('Paramètres OAuth préparés');
//   const authorizationUrl = `${OAUTH_AUTHORIZATION_URL}/connect/authorize?${new URLSearchParams(oauthParams)}`;
//   console.log('URL d\'autorisation construite');

//   // Étape 4 : Rediriger vers l'URL d'authentification
//   window.location.href = authorizationUrl;
// };

// // Fonction pour initier la déconnexion
// export const initiateLogOut = async () => {
//   console.log('Démarrage de initiateLogOut');
  
//   const id_Token = localStorage.getItem('id_token');
//   const logoutparams = {
//     client_id: CLIENT_ID,
//     client_secret: CLIENT_SECRET,
//     post_logout_redirect_uri: Post_logout,
//     id_token_hint: id_Token || '',
//   };

//   console.log('Paramètres de déconnexion préparés');
//   const authorizationUrl = `${OAUTH_AUTHORIZATION_URL}/connect/logout?${new URLSearchParams(logoutparams)}`;

//   // Nettoyer le localStorage et les cookies
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('company');
//   localStorage.removeItem('appId');
//   document.cookie.split(';').forEach((cookie) => {
//     document.cookie = cookie.trim().split('=')[0] + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
//   });

//   console.log('Déconnexion réussie, redirection en cours');
//   window.location.href = authorizationUrl;
// };

// export default { initiateAdminOAuthLogin, initiateLogOut };

// import axios from 'axios';

// // Récupération des variables d'environnement avec des valeurs par défaut
// const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI 
// const OAUTH_AUTHORIZATION_URL = import.meta.env.VITE_REDIRECT_Otenti 
// const Post_logout = import.meta.env.VITE_REDIRECT_post_logout_redirect_uri 
// const BACKEND_URL = import.meta.env.VITE_BACKEND_URL 
// const CLIENT_ID = import.meta.env.VITE_CLIENT_ID 
// const CLIENT_SECRET = import.meta.env.VITE_CLIENT_SECRET 
// const USER_TYPE = import.meta.env.VITE_USER_TYPE

// // Fonction pour générer un code verifier aléatoire
// const generateCodeVerifier = (): string => {
//   const array = new Uint8Array(32);
//   window.crypto.getRandomValues(array);
//   return base64URLEncode(array);
// };

// // Fonction pour encoder en base64URL
// const base64URLEncode = (buffer: ArrayBuffer): string => {
//   return btoa(String.fromCharCode(...new Uint8Array(buffer)))
//     .replace(/\+/g, '-') 
//     .replace(/\//g, '_') 
//     .replace(/=+$/, ''); 
// };

// // Fonction pour générer le code challenge à partir du code verifier
// const generateCodeChallenge = async (codeVerifier: string): Promise<string> => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(codeVerifier);
//   const hash = await window.crypto.subtle.digest('SHA-256', data);
//   return base64URLEncode(hash);
// };


// const getJWTFromBackend = async (): Promise<string | null> => {
//   try {
//     const payload = {
//       client_id: CLIENT_ID,
//       timestamp: Math.floor(Date.now() / 1000),
//     };
//     console.log('Envoi de la requête au backend pour le JWT:', payload);
// const response = await axios.post(`${BACKEND_URL}/api/jwt`, payload);
//     console.log('Réponse du backend:', response.data);
//     return response.data.jwt;
//   } catch (error: any) {
//     console.error('Échec de la récupération du JWT:', {
//       message: error.message,
//       code: error.code,
//       response: error.response?.data,
//       stack: error.stack,
//     });
//     return null;
//   }
// };


// // Fonction principale pour initier la connexion OAuth
// export const initiateAdminOAuthLogin = async () => {
//   console.log('Démarrage de initiateAdminOAuthLogin');

//   // Étape 1 : Obtenir le JWT signé depuis le backend
//   const jwt = await getJWTFromBackend();
//   if (!jwt) {
//     console.error('Échec de la récupération du JWT. Impossible de continuer.');
//     return;
//   }

//   // Étape 2 : Générer le code verifier et le code challenge
//   const codeVerifier = generateCodeVerifier();
//   localStorage.setItem('code_verifier', codeVerifier);
//   console.log('code_verifier', codeVerifier);

//   const codeChallenge = await generateCodeChallenge(codeVerifier);
//   console.log('code_challenge', codeChallenge);
//   console.log('jwt signé:', jwt);
//   // Étape 3 : Construire l'URL d'autorisation
//   const oauthParams = {
//     response_type: 'code',
//     client_id: CLIENT_ID,
//     client_secret: CLIENT_SECRET,
//     redirect_uri: REDIRECT_URI,
//     user_type: USER_TYPE,
//     scope: 'openid email profile offline_access',
//     state: Math.random().toString(36).substring(2),
//     code_challenge: codeChallenge,
//     code_challenge_method: 'S256',
//     client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
//     client_assertion: jwt,
//   };

//   console.log('Paramètres OAuth:', oauthParams);
//   const authorizationUrl = `${OAUTH_AUTHORIZATION_URL}/connect/authorize?${new URLSearchParams(oauthParams)}`;
//   console.log('URL d\'autorisation:', authorizationUrl);

//   // Étape 4 : Rediriger vers l'URL d'authentification
//   window.location.href = authorizationUrl;
// };

// // Fonction pour initier la déconnexion
// export const initiateLogOut = async () => {
//   console.log('Démarrage de initiateLogOut');
//   const codeVerifier = generateCodeVerifier();
//   localStorage.setItem('code_verifier', codeVerifier);
//   console.log('code_verifier', codeVerifier);

//   const codeChallenge = await generateCodeChallenge(codeVerifier);
//   console.log('code_challenge', codeChallenge);

//   const id_Token = localStorage.getItem('id_token');
//   const logoutparams = {
//     client_id: CLIENT_ID,
//     client_secret: CLIENT_SECRET,
//     post_logout_redirect_uri: Post_logout,
//     id_token_hint: id_Token || '',
//   };

//   console.log('Paramètres de déconnexion:', logoutparams);
//   const authorizationUrl = `${OAUTH_AUTHORIZATION_URL}/connect/logout?${new URLSearchParams(logoutparams)}`;
//   console.log('URL de déconnexion:', authorizationUrl);

//   localStorage.removeItem('access_token');
//   localStorage.removeItem('company');
//   localStorage.removeItem('appId');
//   document.cookie.split(';').forEach((cookie) => {
//     document.cookie = cookie.trim().split('=')[0] + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
//   });

//   console.log('Déconnexion réussie');
//   window.location.href = authorizationUrl;
// };

// export default { initiateAdminOAuthLogin, initiateLogOut };




// // C#avec le backend c#
// import axios from 'axios';

// // Environment variables (ensure these are set in your .env file)
// const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI;
// const OAUTH_AUTHORIZATION_URL = import.meta.env.VITE_REDIRECT_Otenti;
// const POST_LOGOUT_REDIRECT_URI = import.meta.env.VITE_REDIRECT_post_logout_redirect_uri;
// const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'https://192.168.0.7:3002';
// const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
// const CLIENT_SECRET = import.meta.env.VITE_CLIENT_SECRET;
// const USER_TYPE = import.meta.env.VITE_USER_TYPE;

// // Generate a random code verifier
// const generateCodeVerifier = () => {
//   const array = new Uint8Array(32);
//   window.crypto.getRandomValues(array);
//   return base64URLEncode(array);
// };

// // Encode to base64 URL-safe
// const base64URLEncode = (buffer) => {
//   return btoa(String.fromCharCode(...new Uint8Array(buffer)))
//     .replace(/\+/g, '-')
//     .replace(/\//g, '_')
//     .replace(/=+$/, '');
// };

// // Generate code challenge from code verifier
// const generateCodeChallenge = async (codeVerifier) => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(codeVerifier);
//   const hash = await window.crypto.subtle.digest('SHA-256', data);
//   return base64URLEncode(hash);
// };

// // Fetch JWT from backend
// const getJWTFromBackend = async () => {
//   try {
//     const payload = {
//       client_id: CLIENT_ID,
//       timestamp: Math.floor(Date.now() / 1000),
//     };
//     console.log('Sending request to backend for JWT:', payload);
//     const response = await axios.post(`${BACKEND_URL}/api/jwt`, payload, {
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       // Handle self-signed certificates (development only)
//       httpsAgent: new (require('https').Agent)({ rejectUnauthorized: false }),
//     });
//     console.log('Backend response:', response.data);
//     return response.data.jwt;
//   } catch (error) {
//     console.error('Failed to fetch JWT:', {
//       message: error.message,
//       code: error.code,
//       response: error.response?.data,
//       stack: error.stack,
//     });
//     throw new Error('Failed to fetch JWT from backend');
//   }
// };

// // Initiate OAuth login
// export const initiateAdminOAuthLogin = async () => {
//   console.log('Starting initiateAdminOAuthLogin');

//   // Step 1: Fetch JWT
//   let jwt;
//   try {
//     jwt = await getJWTFromBackend();
//   } catch (error) {
//     console.error('Failed to retrieve JWT. Aborting OAuth flow.');
//     return;
//   }

//   // Step 2: Generate code verifier and challenge
//   const codeVerifier = generateCodeVerifier();
//   localStorage.setItem('code_verifier', codeVerifier);
//   console.log('code_verifier:', codeVerifier);

//   const codeChallenge = await generateCodeChallenge(codeVerifier);
//   console.log('code_challenge:', codeChallenge);
//   console.log('Signed JWT:', jwt);

//   // Step 3: Build authorization URL
//   const oauthParams = {
//     response_type: 'code',
//     client_id: CLIENT_ID,
//     client_secret: CLIENT_SECRET,
//     redirect_uri: REDIRECT_URI,
//     user_type: USER_TYPE,
//     scope: 'openid email profile offline_access',
//     state: Math.random().toString(36).substring(2),
//     code_challenge: codeChallenge,
//     code_challenge_method: 'S256',
//     client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
//     client_assertion: jwt,
//   };

//   console.log('OAuth parameters:', oauthParams);
//   const authorizationUrl = `${OAUTH_AUTHORIZATION_URL}/connect/authorize?${new URLSearchParams(oauthParams)}`;
//   console.log('Authorization URL:', authorizationUrl);

//   // Step 4: Redirect to authorization URL
//   window.location.href = authorizationUrl;
// };

// // Initiate logout
// export const initiateLogOut = async () => {
//   console.log('Starting initiateLogOut');
//   const codeVerifier = generateCodeVerifier();
//   localStorage.setItem('code_verifier', codeVerifier);
//   console.log('code_verifier:', codeVerifier);

//   const codeChallenge = await generateCodeChallenge(codeVerifier);
//   console.log('code_challenge:', codeChallenge);

//   const idToken = localStorage.getItem('id_token') || '';
//   const logoutParams = {
//     client_id: CLIENT_ID,
//     client_secret: CLIENT_SECRET,
//     post_logout_redirect_uri: POST_LOGOUT_REDIRECT_URI,
//     id_token_hint: idToken,
//   };

//   console.log('Logout parameters:', logoutParams);
//   const logoutUrl = `${OAUTH_AUTHORIZATION_URL}/connect/logout?${new URLSearchParams(logoutParams)}`;
//   console.log('Logout URL:', logoutUrl);

//   // Clear local storage and cookies
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('company');
//   localStorage.removeItem('appId');
//   document.cookie.split(';').forEach((cookie) => {
//     document.cookie = `${cookie.trim().split('=')[0]}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
//   });

//   console.log('Logout successful');
//   window.location.href = logoutUrl;
// };

// export default { initiateAdminOAuthLogin, initiateLogOut };













